module.exports = __webpack_public_path__ + "img/full0-min.aec347de.png";